"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.moment = exports.enviroment = exports.metrics = exports.context = exports.validators = exports.common = exports.constants = void 0;

var _constants = require("./constants");

var _common = require("./common");

var _context = require("./context");

var _metrics = require("./metrics");

var _enviroment = require("./enviroment");

var _moment = require("./moment");

var _validators = require("./validators");

// DEPRECATED IT WILL CONTINUE ON UTILS/COMMON
// DEPRECATED IT WILL CONTINUE ON UTILS/ENVIRONMENT aux
var constants = {
  DEVICES: _constants.DEVICES,
  ENVIRONMENTS: _constants.ENVIRONMENTS,
  NETWORK_STATUS: _constants.NETWORK_STATUS
}; // DEPRECATED IT WILL CONTINUE ON UTILS/COMMON

exports.constants = constants;
var common = {
  giveRandomNumber: _common.giveRandomNumber,
  myAssign: _common.myAssign,
  makeUpObj: _common.makeUpObj,
  cleanUnAllowedKeysInsideObject: _common.cleanUnAllowedKeysInsideObject,
  getUrlParams: _common.getUrlParams,
  makeRequest: _common.makeRequest,
  getDeviceInfo: _common.getDeviceInfo,
  getViewPortSize: _common.getViewPortSize,
  getDeviceKindDependsOnViewPort: _common.getDeviceKindDependsOnViewPort,
  getCurrentLocationProps: _common.getCurrentLocationProps,
  getCookie: _common.getCookie,
  setCookie: _common.setCookie,
  deleteCookie: _common.deleteCookie,
  isIE11: _common.isIE11,
  isSafariBrowser: _common.isSafariBrowser,
  generateComponentId: _common.generateComponentId,
  setUpPropsByDevice: _common.setUpPropsByDevice,
  toKebabCase: _common.toKebabCase,
  getPropKeyByValue: _common.getPropKeyByValue,
  updateObjectInArray: _common.updateObjectInArray,
  insertItemInArray: _common.insertItemInArray,
  insertItemsInArray: _common.insertItemsInArray
};
exports.common = common;
var validators = {
  getValidator: _validators.getValidator,
  validatorList: _validators.validatorList,
  IDENTIFICATION_DOCUMENT_TYPES: _validators.IDENTIFICATION_DOCUMENT_TYPES,
  getDocType: _validators.getDocType
};
exports.validators = validators;
var context = {
  isPriority: _context.isPriority,
  getUserPlatform: _context.getUserPlatform,
  logoutConvergente: _context.logoutConvergente,
  logoutTELCO: _context.logoutTELCO,
  logoutFromMovistar: _context.logoutFromMovistar,
  mapContextParamsToCustoReq: _context.mapContextParamsToCustoReq,
  mapContextParamsToPageEvent: _context.mapContextParamsToPageEvent,
  getSeoInfoFromContext: _context.getSeoInfoFromContext,
  QUEUE_NAMES: _context.QUEUE_NAMES
};
exports.context = context;
var metrics = {
  createEventObject: _metrics.createEventObject,
  createPageEventObject: _metrics.createPageEventObject,
  sendCMSEvent: _metrics.sendCMSEvent,
  checkEventObj: _metrics.checkEventObj,
  buildCMSEventObj: _metrics.buildCMSEventObj
}; // DEPRECATED IT WILL CONTINUE ON UTILS/ENVIRONMENT

exports.metrics = metrics;
var enviroment = {
  findOutEnv: _enviroment.findOutEnv,
  howAppIsRunning: _enviroment.howAppIsRunning
};
exports.enviroment = enviroment;
var moment = {
  changeDashFormatToSlash: _moment.changeDashFormatToSlash,
  getJustDateFromDateTime: _moment.getJustDateFromDateTime,
  getActualDate: _moment.getActualDate,
  addOneMonthToDate: _moment.addOneMonthToDate,
  addMonthsToDate: _moment.addMonthsToDate,
  addYearToDate: _moment.addYearToDate,
  lastDayOfMonth: _moment.lastDayOfMonth,
  getMonthName: _moment.getMonthName,
  getMonthNameByMonthId: _moment.getMonthNameByMonthId,
  getMonthNumber: _moment.getMonthNumber,
  getYear: _moment.getYear,
  getNextYears: _moment.getNextYears,
  expirationDateCheck: _moment.expirationDateCheck,
  getMonthId: _moment.getMonthId,
  getMonthShortName: _moment.getMonthShortName,
  getActualDateString: _moment.getActualDateString,
  changeServerFormatToFrontFormat: _moment.changeServerFormatToFrontFormat,
  changeFrontFormatToServerFormat: _moment.changeFrontFormatToServerFormat,
  changeFrontFormatToUrlFormat: _moment.changeFrontFormatToUrlFormat,
  changeFrontFormatToShortFrontFormat: _moment.changeFrontFormatToShortFrontFormat,
  changeUrlFormatToFrontFormat: _moment.changeUrlFormatToFrontFormat,
  changeUrlFormatToServerFormat: _moment.changeUrlFormatToServerFormat,
  getVerboseDate: _moment.getVerboseDate,
  changeSelectedMonthFormatToDisplayFormat: _moment.changeSelectedMonthFormatToDisplayFormat,
  getDaysUntilNextBill: _moment.getDaysUntilNextBill,
  changeSecondsToDisplayFormat: _moment.changeSecondsToDisplayFormat,
  changeSecondsToMinutesFormat: _moment.changeSecondsToMinutesFormat,
  dateToHHMM: _moment.dateToHHMM,
  getTimestamp: _moment.getTimestamp
};
exports.moment = moment;
var jsUtils = {
  constants: constants,
  // DEPRECATED IT WILL CONTINUE ON UTILS/COMMON
  common: common,
  validators: validators,
  context: context,
  metrics: metrics,
  // DEPRECATED IT WILL CONTINUE ON UTILS/ENVIRONMENT
  enviroment: enviroment,
  moment: moment
};
var _default = jsUtils;
exports["default"] = _default;

//# sourceMappingURL=index.js.map